module.exports = __webpack_public_path__ + "static/image3-2e03b9d700ae01a1b2d1ff86e52cd59d.jpg";